import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogTemplateComponent } from '@optsolservices/ngx-confirm-dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { PrintTriggerDialogComponent } from 'src/app/shared/print-trigger-dialog/print-trigger-dialog.component';
import { PosRcsAccountPaymentWithMoneyEquipmentComponent } from '../components/pos-rcs-account-payment-with-money-equipment/pos-rcs-account-payment-with-money-equipment.component';
import { SendEmailConfirmDialogComponent } from '../components/send-email-confirm-dialog/send-email-confirm-dialog.component';

@Component({
  selector: 'app-rcs-account',
  templateUrl: './rcs-account.component.html',
  styleUrls: ['./rcs-account.component.scss']
})
export class RcsAccountComponent implements OnInit {
  transactions: any[] = [];

  constructor(
    public dialog: MatDialog,
    private baseService: BaseService,
  ) { }

  ngOnInit() {
    this.refresh();
  }

  refresh() {
    this.baseService.executeCommand<any>('portal_rcs_account_transactions_for_store', {})
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.transactions = response.data;
        } else {
          this.transactions = [];
        }
      })
  }

  payAccount(paymentType: string) {
    const ref = this.dialog.open(PosRcsAccountPaymentWithMoneyEquipmentComponent, {
      data: {
        paymentType: paymentType
      },
      width: '800px'
    });

    ref.afterClosed().subscribe(response => {
      this.refresh();
    });
  }

  reversePayment(data: any) {

    const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
      width: '450px',
      data: {
        title: 'Revers RCS payment',
        text: `Are you sure you want to reverse this RCS payment?`,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showConfirmButton: true,
        showCancelButton: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.confirmButtonClicked === true) {
        this.baseService.executeCommand<any>('portal_pos_payment_reverse_rcs_account_transaction', data)
          .subscribe(response => {
              this.refresh();
          })
      }
    });
  }

  generateDocument(document: any) {
    const ref = this.dialog.open(PrintTriggerDialogComponent, {
      data: {
        title: 'Generating RCS Payment Receipt',
        function: 'portal_rcs_account_create_print_trigger',
        postBody: document
      },
      width: '600px'
    });

    ref.afterClosed().subscribe(response => {
      this.refresh();
    });
  }

  // emailDocument(emailInfo: any) {
  //   const dialogRef = this.dialog.open(SendEmailConfirmDialogComponent, {
  //     width: '450px',
  //     data: {
  //       createEmailFunction: 'portal_tfg_account_create_email',
  //       email: emailInfo,
  //       form: {
  //         name: '',
  //         email: ''
  //       }
  //     }
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     this.refresh();
  //   });
  // }

  // showEmailDetails(dataItem: any, index: number) {
  //   return dataItem.emails ? true : false;
  // }

  downloadResource(resource: any) {
    this.baseService.downloadResource(resource.apiResourceKey, resource.fileName, resource.mimeType);
  }
}
